const getters = {
  userInfo: state => state.app.userInfo,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js